import React, { forwardRef } from "react";

/**
 * HTML2Canvas-SAFE Story Card
 * - No gradients (replaced with solid colors)
 * - No transparency gradients
 * - No conic / radial / backdrop-filter
 * - Only pure CSS html2canvas-supported styles
 */

const StoryCard = forwardRef(({ city, country, score, imageUrl }, ref) => {
  return (
    <div
      ref={ref}
      style={{
        width: 1080,
        height: 1920,
        position: "relative",
        overflow: "hidden",
        fontFamily: "Inter, system-ui, sans-serif",
        backgroundColor: "#111827", // safe dark background
      }}
    >
      {/* BACKGROUND IMAGE */}
      <img
        src={imageUrl}
        alt={city}
        crossOrigin="anonymous"
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          opacity: 0.45,
          filter: "saturate(1.1)",
          zIndex: 1,
        }}
      />

      {/* DARK OVERLAY — SAFE (no gradients) */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.55)",
          zIndex: 2,
        }}
      />

      {/* TEXT CONTENT */}
      <div
        style={{
          position: "relative",
          zIndex: 3,
          width: "100%",
          height: "100%",
          padding: "160px 120px",
          color: "white",
        }}
      >
        {/* City */}
        <div
          style={{
            fontSize: 120,
            fontWeight: 800,
            letterSpacing: "-0.03em",
            lineHeight: 1.05,
            marginBottom: 24,
            maxWidth: "750px",
          }}
        >
          {city}
        </div>

        {/* Country */}
        <div
          style={{
            fontSize: 54,
            opacity: 0.9,
            fontWeight: 500,
            marginBottom: 60,
          }}
        >
          {country}
        </div>

        {/* SAFE WSI BADGE — no conic gradient */}
        <div
          style={{
            position: "absolute",
            top: 180,
            right: 120,
            width: 260,
            height: 260,
            borderRadius: "50%",
            backgroundColor: "#8B5CF6", // purple brand color
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 20px 60px rgba(0,0,0,0.4)",
          }}
        >
          <div
            style={{
              width: 220,
              height: 220,
              borderRadius: "50%",
              backgroundColor: "#111827",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
            }}
          >
            <div style={{ fontSize: 80, fontWeight: 800 }}>{score}</div>
            <div style={{ fontSize: 30, opacity: 0.8 }}>WSI</div>
          </div>
        </div>

        {/* INFORMATION BOX (SAFE — no fade, no border transparency) */}
        <div
          style={{
            position: "absolute",
            bottom: 280,
            left: 120,
            right: 120,
            padding: "40px 48px",
            borderRadius: 40,
            backgroundColor: "rgba(17,24,39,0.95)", // solid dark blue-gray
            border: "1px solid rgba(255,255,255,0.15)",
            color: "white",
          }}
        >
          <div style={{ fontSize: 40, fontWeight: 600, marginBottom: 12 }}>
            Women Safety Index
          </div>
          <div style={{ fontSize: 32, opacity: 0.85, lineHeight: 1.4 }}>
            Compare city-level women’s safety scores worldwide with SafeShe Atlas.
          </div>
        </div>

        {/* FOOTER BRAND */}
        <div
          style={{
            position: "absolute",
            bottom: 120,
            left: 120,
            right: 120,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            color: "rgba(255,255,255,0.85)",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
            {/* Brand Icon (SAFE — replaced radial gradient) */}
            <div
              style={{
                width: 60,
                height: 60,
                borderRadius: 20,
                backgroundColor: "#8B5CF6", // brand purple
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 800,
                fontSize: 32,
                color: "white",
              }}
            >
              SA
            </div>

            <div>
              <div style={{ fontWeight: 700, fontSize: 32 }}>SafeShe Atlas</div>
              <div style={{ fontSize: 26, opacity: 0.75 }}>
                Global Women Safety Index
              </div>
            </div>
          </div>

          <div style={{ fontSize: 28, opacity: 0.75 }}>safesheatlas.com</div>
        </div>
      </div>
    </div>
  );
});

export default StoryCard;
